// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 63.30.0, gate E12.5 pass 1 — the moves a DSR deletion run's status may
 * make, read by the status route and the page. An executing run is not
 * cancelled and is not set back to pending (that was the way round the cancel
 * guard: in progress → pending → cancelled); a finished or cancelled run is
 * final.
 */
export const DSR_DELETION_RUN_TRANSITIONS = {
    pending: ['in_progress', 'cancelled'],
    in_progress: ['completed', 'completed_with_exceptions'],
    completed: [],
    completed_with_exceptions: [],
    cancelled: [],
};
/**
 * fix-sprint #431 — the states a vendor follow-up actually holds. The union
 * also said `sent` and `overdue`, which no code path ever writes:
 * `createVendorFollowup` writes `pending`, `recordVendorConfirmation`
 * `confirmed` and `escalateVendorDeletion` `escalated`. Overdue is not a state
 * — it is derived on read (`is_overdue`: pending and past its deadline) — and
 * the Vendor Verification page offered both as status filters that could never
 * match a row.
 */
export const VENDOR_FOLLOWUP_STATUSES = ['pending', 'confirmed', 'escalated'];
/**
 * Fix sprint #431 (gate E12.5 remediation 1) — how a vendor's deletion
 * confirmation reached the organisation, offered by the Record confirmation
 * dialog on Vendor Requests and stored as `vendor_confirmation.method`.
 */
export const VENDOR_CONFIRMATION_METHODS = ['email', 'portal', 'letter', 'phone', 'other'];
//# sourceMappingURL=deletion-orchestration.js.map